export const PROD_AD_SDK_JS_LINK = '//adsfs.heytapimage.com/mp/app/content/index.js';

export const PROD_COMMENT_SDK_JS_LINK
  = '//static-cpc.heytapimage.com/comment-sdk-prod/feeds/shop/comment-sdk-combine@latest.js';

export const PROD_LOTTIE_SDK_JS_LINK
  = '//static-cpc.heytapimage.com/userfiles/uploads/jslib/lottie_svg.min.js';
